<template>
  <div class="box3">
    <pageTitle
      title="可刚需可副业  要生活也要诗和远方"
      text="庙堂之高，江湖之远，均有容身所在"
      titleColor="#1A0400"
      titColor="#665552"
    />
    <div class="wrap1">
      <div class="title">职业发展路径</div>
      <div class="subTitle">创业发展</div>
      <div class="img1"></div>
      <div class="box">
        <div class="left">
          <div class="item">工作室</div>
          <div class="item">MCN工作室</div>
          <div class="item">传媒公司</div>
          <div class="item">变现分成</div>
        </div>
        <div class="right">
          <div class="item">自媒体</div>
          <div class="item">自媒体达人</div>
          <div class="item">网红艺人</div>
          <div class="item">商业变现</div>
        </div>
      </div>
      <div class="subTitle">职场发展</div>
      <div class="img2"></div>
      <div class="heng">
        <div class="item">新媒体运营</div>
        <div class="item">直播运营</div>
        <div class="item">短视频运营</div>
        <div class="item">社群运营</div>
      </div>
    </div>
    <div class="wrap2">
      <h1 class="wrap-title">适学人群</h1>
      <div class="wrap-content">
        <span>
          <img src="../../../assets/coursePage/newMedia/box3/1.png" alt="" />
          <h1>转行就业人群</h1>
          <p>
            需要转行、涨薪人群，如行政、人事、财务等，想换个轻松高薪行业转行就业，抓住时代红利。
          </p>
        </span>

        <span>
          <img src="../../../assets/coursePage/newMedia/box3/2.png" alt="" />
          <h1>应届大学生</h1>
          <p>本专业不好找工作，或对新媒体行业感兴趣，亟需行业经验快速就业。</p>
        </span>

        <span>
          <img src="../../../assets/coursePage/newMedia/box3/3.png" alt="" />
          <h1>思维活跃的年轻人</h1>
          <p>
            00后，喜欢创新、喜欢接触新兴事物，不愿按部就班，就业的同时实现个人价值。
          </p>
        </span>

        <span>
          <img src="../../../assets/coursePage/newMedia/box3/4.png" alt="" />
          <h1>自由职业/创业者</h1>
          <p>用新媒体赋能自身，驱动商业变现，拓展新的职业能力。</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.box3 {
  padding: 80px 0px 88px;
  width: 100%;
  background: #dbf4ff;
  background: skyblue;
  position: relative;
  background: #fefbf3 url("../../../assets/coursePage/newMedia/box3/bgc.png")
    no-repeat;
  background-size: cover;
  .wrap1 {
    width: 690px;

    margin: 48px auto 0;
    border-radius: 20px;
    overflow: hidden;
    border: 2px solid #ffffff;
    background: linear-gradient(0deg, #ffe2dc 0%, #fff5f3 100%);
    padding-bottom: 202px;
    .title {
      background: url("../../../assets/coursePage/newMedia/box3/shadow.png")
        no-repeat;
      background-size: 154px 74px;
      background-position: center;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 74px;
      margin: 35px 0 19px;
      text-align: center;
    }
    .subTitle {
      /* background: url("../../../assets/coursePage/newMedia/box3/itembgc.png")
        no-repeat;
      background-size: cover; */

      background: #ff7a39;
      width: 281px;
      height: 60px;
      border-radius: 15px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 60px;
      text-align: center;
      margin: 0 auto;
    }
    .img1 {
      background: url("../../../assets/coursePage/newMedia/box3/img1.png")
        no-repeat;
      background-size: contain;
      width: 628px;
      height: 138px;
      margin: 0 auto;
    }
    .img2 {
      background: url("../../../assets/coursePage/newMedia/box3/img2.png")
        no-repeat;
      background-size: contain;
      width: 628px;
      height: 260px;
      margin: 0 auto;
    }
    .box {
      width: 100%;
      justify-content: space-between;
      display: flex;
      padding: 0 51px;
      box-sizing: border-box;
      margin-top: -90px;
      .item {
        width: 270px;
        height: 60px;
        background: #ffe6e1;
        border: 1px solid #ffffff;

        border-radius: 15px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #665552;
        line-height: 60px;
        text-align: center;
        margin-bottom: 20px;
      }
      .left,
      .right {
        .item:last-child {
          font-weight: 500;
          color: #ec3e15;
          margin-bottom: 38px;
        }
      }
    }
    .heng {
      width: 100%;
      justify-content: space-between;
      display: flex;
      padding: 0 42px;
      box-sizing: border-box;
      margin-top: -212px;
      .item {
        width: 139px;
        height: 60px;
        background: #feece7;
        border: 1px solid #ffffff;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #665552;
        border-radius: 15px;
        line-height: 60px;
        text-align: center;
      }
    }
  }
  .wrap2 {
    width: 690px;
    padding-bottom: 48px;
    border-radius: 20px;
    margin: 35px auto 0;
    overflow: hidden;
    box-sizing: border-box;
    background: #ffffff;
    /* border: 2px solid #ffffff; */

    background-position: center;
    box-shadow: 0px 5px 38px 0px rgba(255, 126, 96, 0.19);
    .wrap-title {
      background: url("../../../assets/coursePage/newMedia/box3/shadow.png")
        no-repeat;
      background-size: 154px 74px;
      background-position: center;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 74px;
      margin: 27px 0 11px;
      text-align: center;
    }
    .wrap-content {
      display: flex;
      flex-wrap: wrap;
      background: #ffffff
        url("../../../assets/coursePage/newMedia/box3/xian.png") no-repeat;
      background-size: 620px 680px;
      background-position: center 20px;
      span {
        display: block;
        width: 344px;
        padding: 0 36px;
        box-sizing: border-box;
        text-align: center;
        img {
          width: 88px;
          height: 100px;
        }
        h1 {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #1a0400;
          line-height: 26px;
          margin: 32px auto 24px;
        }
        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #665552;
          line-height: 38px;
          margin-top: 16px;
        }
      }
      span:nth-child(3),
      span:nth-child(4) {
        margin-top: 70px;
      }
    }
  }
}
</style>
